const POProductType = {
  SET_ADD_PO_PRODUCT: "SET_ADD_PO_PRODUCT",
  SET_PO_PRODUCT_LIST: "SET_PO_PRODUCT_LIST",
  SET_UPDATE_PO_PRODUCT: "SET_UPDATE_PO_PRODUCT",
  SET_UPLOAD_CSV_FILE: "SET_UPLOAD_CSV_FILE",
  REQUEST_PO_GENERATE: "REQUEST_PO_GENERATE",
  CREATE_PO_GENERATE: "CREATE_PO_GENERATE",
  PO_LIST: "PO_LIST",
  ORDER_ITEMS: "ORDER_ITEMS",
  DELETE_ORDER_ITEMS: "DELETE_ORDER_ITEMS",
  PO_ORDER_ACCEPTANCE: "PO_ORDER_ACCEPTANCE",
  PO_VENDOR_LIST: "PO_VENDOR_LIST",
  PO_SELLER_UNIQUE_LIST: "PO_SELLER_UNIQUE_LIST",
  SET_UPDATE_PO_ORDER_QTY: "SET_UPDATE_PO_ORDER_QTY",
  SET_UPLOAD_DDC_CSV_FILE: "SET_UPLOAD_DDC_CSV_FILE",
  SET_DELIVERY_CHARGE: "SET_DELIVERY_CHARGE",
  CANCEL_ORDER_ITEM: "CANCEL_ORDER_ITEM",
  UPDATE_LANDING_COST: "UPDATE_LANDING_COST",
};

export interface AddPoProduct {
  product_id: number;
  qty: number;
  state: string;
}

export interface GetPoProduct {
  limit: number;
  search: any;
  page: number;
}

export interface UpdatePoProduct {
  id: number;
  product_name: string;
  product_code: number;
  sku: number;
  mrp: any;
  landing_cost: any;
  po_qty: number;
  vendor_id: number;
  tax: number;
}

export interface DeletePoProduct {
  id: number;
}

export interface UploadPoProduct {
  csv_file: any;
}

export interface Payment {
  receipt: any;
  id: any;
}

export interface OrderItems {
  id: any;
}

export interface DeleteOrderItems {
  id: any;
}

export interface acceptRejectPO {
  id: any;
  status: any;
  without_margin_price: number;
  price: number;
  tax: number;
  qty: number;
}

export interface GetPoList {
  poOrderStatus: string;
}

export interface VendorList {
  city: string;
}

export interface RequestPoGenerate {
  delivery_charge: string;
  terms: any;
}

export interface UpdatePoOrderQty {
  id: number;
  action: any;
  supply_qty: number;
}

export interface UploadDDCProduct {
  csv_file: any;
}

export interface UpdateDeliveryChargeAmount {
  id: number;
  delivery_charge: any;
}

export interface CancelOrderStatus {
  id: number;
}

export interface UpdateLandingCost {
  id: number;
  landing_cost: number;
}

export default POProductType;
